/* eslint-disable max-lines */
import { amenitiesOptions } from "@components/SearchResults/SearchFilters/filterOptions"
import algoliasearch from "algoliasearch/lite"
import { isEmpty } from "lodash"
import {
  CurrConvertPrice,
  SizeConvert,
  SizeConvertNO,
  calcPrice,
} from "@components/CurrencyConverter/CurrConvertPrice"
import pluralize from "./pluralize"
import {
  commercialPropertiesRentURL,
  commercialPropertiesSaleURL,
  getPropertyURL,
  offplanResultsURL,
  propertiesRentURL,
  propertiesSaleURL,
  propertyRentRegex,
  propertySaleRegex,
} from "./urls"
import JSZip from "jszip";
import {
  capitalize as capitalizeText,
  formatNumber,
  slugToTitle,
} from "./utils"
import useFeatures from "@hooks/dataHooks/useFeatures"
import slugify from "slugify"
export const removeSpecialChar = (val, symbol = "-") => {
  if (!isEmpty(val)) {
    return val
      .replace(/[^\w\s]/gi, " ")
      .replace(/\s\s+/g, " ")
      .replace(/ /gi, symbol)
      .toLowerCase()
  }
  return val
}



export const DEFAULT_AREA = ""

export const algoliaClient = algoliasearch(
  "D4VBAN0OOQ",
  process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
)

export const getFurnishedPath = (furnished) => {
  let url = ""
  if (furnished) {
    url = "furnished/"
  }
  return url
}

export const getStatusTypePath = (val) => {
  let url = ""
  if (val) {
    url = `completion-${val}/`
  }
  return url
}



export const getAreaPath = (areas) => {
  let url = ""
  const areaSlugs =
    typeof areas === "string"
      ? areas
      : areas?.map((area) => (area.slug ? area.slug : area))

  if (!areaSlugs || isEmpty(areaSlugs)) {
    url = ""
    // url = `in-${DEFAULT_AREA}/`
  } else if (typeof areaSlugs === "string") {
    url = `in-${areaSlugs}/`
  } else if (areaSlugs.length > 0) {
    url = `in-${areaSlugs.join("-or-")}/`
  }

  return url
}

export const getProppertyTypePath = (propertyType) => {
  let url = ""
  if (propertyType) {
    url = `type-${propertyType}/`
  }
  return url
}

export const getCrmidPath = (crm_id) => {
  let url = ""
  if (crm_id) {
    url = `crm-id-${crm_id}/`
  }
  return url
}

export const updatePropertyTypePath = (propertyType, path) => {
  let url = path
  const DEFAULT_PROPERTY_TYPE = "properties"
  //const DEFAULT_PROPERTY_TYPE = ""
  const propType = propertyType || DEFAULT_PROPERTY_TYPE
  const isCommercial = path.includes("commercial-")

  if (isCommercial) {
    url = path.replace("commercial-", "")
  }

  let prevPropertyType = ""



  if (url.match(propertySaleRegex)) {
    const initIndex = 5
    const lastIndex = url.indexOf("-for-sale")
    prevPropertyType = url.substring(initIndex, lastIndex)
  } else if (url.match(propertyRentRegex)) {
    const initIndex = 5
    const lastIndex = url.indexOf("-for-rent")
    prevPropertyType = url.substring(initIndex, lastIndex)
  }
  // else if (url.includes(offplanResultsURL)) {
  //   DEFAULT_PROPERTY_TYPE = "offplan"
  //   const urlArr = url.split("/")
  //   prevPropertyType = urlArr[2]
  // }

  //console.log("updatePropertyTypePath ==> 1", url, propType, prevPropertyType)

  url = url.replace(prevPropertyType, propType)

  //console.log("updatePropertyTypePath ==> 2", url, propType, prevPropertyType)

  if (isCommercial) {
    url = url.replace(
      propType || DEFAULT_PROPERTY_TYPE,
      `commercial-${propType}`
    )
  }

  return url
}

export const getPropertyTypeFromPath = (path) => {
  let propertyType = ""

  if (path.match(propertySaleRegex)) {
    const initIndex = 5
    const lastIndex = path.indexOf("-for-sale")

    propertyType = path.substring(initIndex, lastIndex)
  }

  if (path.match(propertyRentRegex)) {
    const initIndex = 5
    const lastIndex = path.indexOf("-for-rent")

    propertyType = path.substring(initIndex, lastIndex)
  }

  if (path.includes(offplanResultsURL)) {
    const valuePath = path.split("/")?.find((item) => item.includes("type-"))
    const value = valuePath?.replace("type-", "")
    propertyType = value || ""
  }

  propertyType = propertyType.replace("commercial-", "")

  if (
    propertyType === "properties" ||
    propertyType === "property" ||
    propertyType === "offplan"
  ) {
    propertyType = ""
  }

  return propertyType
}

export const getDeveloperPath = (developerName) => {
  let url = ""
  if (developerName) {
    url = `developed-by-${developerName}/`
  }
  return url
}

export const getCityPath = (city) => {
  let url = ""
  if (city) {
    url = `city-area-${slugify(city)}/`
  }
  return url
}


export const getBedroomPath = (minBedroom, maxBedroom) => {
  let url = ""
  if (minBedroom && maxBedroom) {
    url = `with-${minBedroom}-to-${maxBedroom}-bedrooms/`
  } else if (maxBedroom) {
    url = `under-${maxBedroom}-bedrooms/`
  } else if (minBedroom) {
    url = `more-than-${minBedroom}-bedrooms/`
  }
  return url
}

export const getBathroomPath = (bathrooms) => {
  let url = ""
  if (bathrooms) {
    url = `${bathrooms}-and-more-bathrooms/`
  }
  return url
}

export const getPricePath = (minPrice, maxPrice) => {
  let url = ""
  if (minPrice && maxPrice) {
    url = `between-${minPrice}-and-${maxPrice}/`
  } else if (maxPrice) {
    url = `below-${maxPrice}/`
  } else if (minPrice) {
    url = `above-${minPrice}/`
  }
  return url
}

export const getSizePath = (minSize, maxSize) => {
  let url = ""
  if (minSize && maxSize) {
    url = `from-${minSize}-to-${maxSize}-sqft/`
  } else if (maxSize) {
    url = `under-${maxSize}-sqft/`
  } else if (minSize) {
    url = `more-than-${minSize}-sqft/`
  }
  return url
}

export const getSortPath = (sort) => {
  let url = ""
  if (sort?.includes("price_asc")) {
    url = "sortby-price-asc/"
  } else if (sort?.includes("price_desc")) {
    url = "sortby-price-desc/"
  }
  return url
}

export const getOffplanStatusPath = (status) => {
  let url = ""
  if (status) {
    url = `status-${status}/`
  }
  return url
}

export const getAmenitesPath = (amenities) => {
  if (isEmpty(amenities)) return ""

  if (Array.isArray(amenities)) {
    let url = "with-amenities-"
    amenities.forEach((amenity, index) => {
      url += `${amenity.value || amenity}${
        index === amenities.length - 1 ? "/" : "-or-"
      }`
    })

    return url
  }

  return `with-amenities-${amenities}/`
}

export const getOffAmenitesPath = (amenities) => {
  if (isEmpty(amenities)) return ""
  if (Array.isArray(amenities)) {
    let url = "with-features-"
    amenities.forEach((amenity, index) => {
      url += `${amenity.value || amenity}${
        index === amenities.length - 1 ? "/" : "-or-"
      }`
    })

    return url
  }

  return `with-features-${amenities}/`
}

export const getPagePath = (page) => {
  let url = ""
  if (page > 1) {
    url = `page-${page}/`
  }
  return url
}

export const addTraillingSlash = (url) => {
  let newUrl = url

  if (url && url[url.length - 1] !== "/") {
    newUrl += "/"
  }

  newUrl = newUrl.replace(/\/{2,}/g, "/")

  return newUrl
}

export const updateAlgoliaResutls = async (filterQuery, pageUrlData, setSearchState) => {
  const index = algoliaClient.initIndex(
    pageUrlData.sortVal ? pageUrlData.sortVal : pageUrlData.indexVal
  );

  const storeCompressedData = async (key, jsonData) => {
    if (key.includes("_map_")) return; // Prevent storing map view data
    const zip = new JSZip();
    zip.file("data.json", JSON.stringify(jsonData));
    const compressedBlob = await zip.generateAsync({ type: "base64" });
    localStorage.setItem(key, compressedBlob);
  };
  
  const getDecompressedData = async (key) => {
    if (key.includes("_map_")) return null; // Force real-time data for map view
    const compressedData = localStorage.getItem(key);
    if (!compressedData) return null;
    const zip = new JSZip();
    const unzipped = await zip.loadAsync(compressedData, { base64: true });
    const jsonData = await unzipped.file("data.json").async("text");
    return JSON.parse(jsonData);
  };

  const isMapView = pageUrlData.layoutVal === "map";
  let hitsPerPage = 12;

  switch (pageUrlData.layoutVal) {
    case "map":
      hitsPerPage = 50;
      break;
    case "list":
      hitsPerPage = 10;
      break;
    case "grid":
      hitsPerPage = pageUrlData.departmentVal === "new_developments" ? 15 : 10;
      break;
    default:
      hitsPerPage = 15;
      break;
  }

  const cacheKey = `algolia_${pageUrlData.indexVal}_${pageUrlData.layoutVal}_${window.location.pathname}`;
  const cacheExpiration = 1000 * 60 * 5;

  // 🔹 Clear expired cache
  Object.keys(localStorage).forEach(async (key) => {
    try {
      const data = await getDecompressedData(key);
      if (data?.timestamp && Date.now() - data.timestamp >= cacheExpiration) {
        localStorage.removeItem(key);
      }
    } catch {
      localStorage.removeItem(key);
    }
  });

  // 🔹 Clear old cache if switching to map view
  if (isMapView) {
    Object.keys(localStorage).forEach((key) => {
      if (key.includes("_map_")) {
        localStorage.removeItem(key);
      }
    });
  }

  let cachedData = await getDecompressedData(cacheKey);

  if (cachedData && !isMapView) { // Use cache only if not in map view
    if (cachedData.timestamp && Date.now() - cachedData.timestamp < cacheExpiration) {
      setSearchState(cachedData.data);
      return;
    } else {
      localStorage.removeItem(cacheKey);
    }
  }

  // 🔹 API Call (Always fetch new data for map view)
  try {
    const searchData = await index.search("", {
      filters: filterQuery,
      page: isMapView ? 0 : pageUrlData.pageVal - 1,
      hitsPerPage,
    });

    if (!isMapView) {
      await storeCompressedData(cacheKey, {
        data: searchData,
        timestamp: Date.now(),
      });
    }

    setSearchState(searchData);
  } catch (error) {
    console.error("🚨 API Fetch Error", error);
  }
};





export const updateAlgoliaResutlsNew = (pageUrlData, filterQuery, pageNumber, showMap) => {

    const index = algoliaClient.initIndex(
      pageUrlData.sortVal ? pageUrlData.sortVal : pageUrlData.indexVal
    )
  
    const isMapView = showMap === "map"
    let hitsPerPage = 12

    if(showMap){
      hitsPerPage = 1000
    }
  
    switch (pageUrlData.layoutVal) {
      // case "map":
      //   hitsPerPage = 1000
      //   break
      case "list":
        hitsPerPage = 10
        break
      case "grid":
        hitsPerPage = pageUrlData.departmentVal === "new_developments" ? 15 : 10
        break
      default:
        hitsPerPage = 15
        break
    }
  
    return index.search(
      "",
      {
        filters: `${filterQuery}`,
        page: isMapView ? 0 : pageNumber - 1,
        hitsPerPage,
      }
    )
}

// Create URL
export const createResultsUrl = ({
  departmentVal,
  searchTypeVal,
  areaVal,
  minBedVal,
  maxBedVal,
  minPriceVal,
  maxPriceVal,
  minAreaSizeVal,
  maxAreaSizeVal,
  buildingVal,
  sortVal,
  amenitiesVal,
  offplanStatusVal,
  developerVal,
  furnishVal,
  crm_id,
  statusTypeVal,
  cityVal,
  mapview,
}) => {
  const isResidential = departmentVal === "residential"
  const isOffplan = departmentVal === "new_developments"
  const isCommercial = departmentVal === "commercial"
  let url = ""

  if (searchTypeVal === "sales") {
    if (isResidential) {
      url = propertiesSaleURL
    } else if (isCommercial) {
      url = commercialPropertiesSaleURL
    } else if (isOffplan) {
      url = offplanResultsURL
    }
  } else if (searchTypeVal === "lettings") {
    if (isResidential) {
      url = propertiesRentURL
    } else if (isCommercial) {
      url = commercialPropertiesRentURL
    }
  }



  url += getAreaPath(areaVal)


  if (isOffplan) {
    url += getProppertyTypePath(buildingVal)
  } else {
    url = updatePropertyTypePath(buildingVal, url)
  }



  url += getPricePath(minPriceVal, maxPriceVal)
  url += getBedroomPath(minBedVal, maxBedVal)
  url += getSizePath(minAreaSizeVal, maxAreaSizeVal)
  if (isOffplan) {
    url += getOffAmenitesPath(amenitiesVal)
  }
  else {
    url += getAmenitesPath(amenitiesVal)

  }
  url += getOffplanStatusPath(offplanStatusVal)
  url += getDeveloperPath(developerVal)
  url += getCityPath(cityVal)
  url += getFurnishedPath(furnishVal)
  url += getSortPath(sortVal)
  url += getCrmidPath(crm_id)
  url += getStatusTypePath(statusTypeVal)
  if(mapview){
    url += "map-view"
  }
  return addTraillingSlash(url)
}

export const parseResultsUrl = (location) => {
  // split the URL
  if (location?.pathname) {
    let pathParams = ""
    let departmentVal = "residential"
    let searchTypeVal = ""
    let areaVal = ""
    let bedVal = ""
    let minBedVal = ""
    let maxBedVal = ""
    let minPriceVal = ""
    let maxPriceVal = ""
    let minAreaSizeVal = ""
    let maxAreaSizeVal = ""
    let pageVal = "1"
    let buildingVal = ""
    let sortVal = ""
    let layoutVal = ""
    let indexName = process.env.GATSBY_ALGOLIA_INDEX_NAME
    const mustIncludeVal = ""
    let furnishVal = false
    let branchVal = ""
    let amenitiesVal = ""
    let offplanStatusVal = ""
    let developerVal = ""
    let cityVal = ""
    let crm_id = ''
    let statusTypeVal = ''
    const isSales = location.pathname.match(/\/buy\/[^/]+-for-sale\//)?.length > 0
    const isLettings = location.pathname.match(/\/let\/[^/]+-for-rent\//)?.length > 0
    const isOffplan = location.pathname.indexOf(offplanResultsURL) > -1
    const isCommercial = location.pathname.indexOf("commercial-") > -1

    if (isSales) {
      pathParams = location.pathname.replace(
        location.pathname?.match(/\/buy\/[^/]+-for-sale\//)?.[0],
        ""
      )
      searchTypeVal = "sales"
    } else if (isLettings) {
      pathParams = location.pathname.replace(
        location.pathname?.match(/\/let\/[^/]+-for-rent\//)?.[0],
        ""
      )
      searchTypeVal = "lettings"
    } else if (isOffplan) {
      pathParams = location.pathname.replace(offplanResultsURL, "")
      searchTypeVal = "sales"
      indexName =
        process.env.GATSBY_ALGOLIA_NEW_DEVELOPMENTS_INDEX_NAME ||
        "prod_new_developments"
      departmentVal = "new_developments"
    }
    if (isCommercial) {
      departmentVal = "commercial"
    }

    if (location.pathname.match(propertySaleRegex)) {
      const initIndex = 5
      const lastIndex = location.pathname.indexOf("-for-sale")
  
      buildingVal = location.pathname.substring(initIndex, lastIndex)
    }
  
    if (location.pathname.match(propertyRentRegex)) {
      const initIndex = 5
      const lastIndex = location.pathname.indexOf("-for-rent")
  
      buildingVal = location.pathname.substring(initIndex, lastIndex)
    }
  
    if (location.pathname.includes(offplanResultsURL)) {
      const valuePath = location.pathname.split("/")?.find((item) => item.includes("type-"))
      const value = valuePath?.replace("type-", "")
      buildingVal = value || ""
    }
  
    buildingVal = buildingVal.replace("commercial-", "")
  
    if (
      buildingVal === "properties" ||
      buildingVal === "property" ||
      buildingVal === "offplan"
    ) {
      buildingVal = ""
    }

    // buildingVal = getPropertyTypeFromPath(location.pathname)
    if (pathParams) {
      // following could be regexp
      const pathUri = pathParams.split("/")

      // console.log("pathUri ==>", location.pathname, pathParams, pathUri)
      // lets loop
      for (let vi = 0; vi <= pathUri.length; vi++) {
        // check for area
        if (typeof pathUri[vi] === "undefined") {
          continue
        }

        // Area
        // eg: in-hampton-in-arden-and-great-barr
        // convert to ["hampton-in-arden", "great-barr"]
        if (
          pathUri[vi].indexOf("in-") >= 0 &&
          !pathUri[vi].includes("with-amenities-") &&
          !pathUri[vi].includes("with-features-") &&
          !pathUri[vi].includes("developed-by")
        ) {
          // remove the first 3 chars
          const areaFilt = pathUri[vi]?.substr(3)?.split("-or-")

          if (areaFilt[0] !== DEFAULT_AREA) {
            areaVal = areaFilt
          }
        }

        // Bedrooms
        if (pathUri[vi].indexOf("-and-more-") >= 0) {
          bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
        }

        // Property type
        // if (pathUri[vi].indexOf("type-") >= 0) {
        //   buildingVal = pathUri[vi].replace("type-", "")
        // }

        // Price
        if (
          pathUri[vi].indexOf("between-") >= 0 ||
          pathUri[vi].indexOf("above-") >= 0 ||
          pathUri[vi].indexOf("below-") >= 0
        ) {
          const priceFilt1 = pathUri[vi].split("above-")
          if (priceFilt1[1]) {
            minPriceVal = priceFilt1[1]
          }
          const priceFilt2 = pathUri[vi].split("below-")
          if (priceFilt2[1]) {
            maxPriceVal = priceFilt2[1]
          }
          const priceFilt3 = pathUri[vi].split("between-")
          if (priceFilt3[1]) {
            const priceFilt4 = priceFilt3[1].split("-and-")
            minPriceVal = priceFilt4[0]
            maxPriceVal = priceFilt4[1]
          }
        }

        // Bedrooms
        if (pathUri[vi].indexOf("-bedroom") >= 0) {
          let replaceText = "-bedroom"

          if (pathUri[vi].indexOf("-bedrooms") >= 0) {
            replaceText = "-bedrooms"
          }

          const areaFilt1 = pathUri[vi].split("more-than-")
          if (areaFilt1[1]) {
            minBedVal = areaFilt1[1].replace(replaceText, "")
          }
          const areaFilt2 = pathUri[vi].split("under-")
          if (areaFilt2[1]) {
            maxBedVal = areaFilt2[1].replace(replaceText, "")
          }
          const areaFilt3 = pathUri[vi].split("with-")
          if (areaFilt3[1]) {
            const areaFilt4 = areaFilt3[1].split("-to-")
            minBedVal = areaFilt4[0].replace(replaceText, "")
            maxBedVal = areaFilt4[1].replace(replaceText, "")
          }
        }

        // Area
        if (pathUri[vi].indexOf("-sqft") >= 0) {
          const areaFilt1 = pathUri[vi].split("more-than-")
          if (areaFilt1[1]) {
            minAreaSizeVal = areaFilt1[1].replace("-sqft", "")
          }
          const areaFilt2 = pathUri[vi].split("under-")
          if (areaFilt2[1]) {
            maxAreaSizeVal = areaFilt2[1].replace("-sqft", "")
          }
          const areaFilt3 = pathUri[vi].split("from-")
          if (areaFilt3[1]) {
            const areaFilt4 = areaFilt3[1].split("-to-")
            minAreaSizeVal = areaFilt4[0].replace("-sqft", "")
            maxAreaSizeVal = areaFilt4[1].replace("-sqft", "")
          }
        }

        // Sort by
        if (pathUri[vi].indexOf("sortby-") >= 0) {
          const sortValFilt = pathUri[vi].replace("sortby-", "")

          if (sortValFilt === "") {
            sortVal = indexName
            // console.log(sortVal)
          }

          if (sortValFilt === "price-asc") {
            sortVal = `${indexName}_price_asc`
          }

          if (sortValFilt === "price-desc") {
            sortVal = `${indexName}_price_desc`
          }

          if (sortValFilt === "newest") {
            sortVal = `${indexName}_newest`
          }

          if (sortValFilt === "oldest") {
            sortVal = `${indexName}_oldest`
          }
        }

       
        if(isOffplan){
         // Features
         if (pathUri[vi].indexOf("with-features-") >= 0) {
          const amenityValFilt = pathUri[vi].replace("with-features-", "")
          amenitiesVal = amenityValFilt.split("-or-")
        }
      }
      else {
         // amenities
         if (pathUri[vi].indexOf("with-amenities-") >= 0) {
          const amenityValFilt = pathUri[vi].replace("with-amenities-", "")
          amenitiesVal = amenityValFilt.split("-or-")
        }
      }

        // furnished
         if (!isOffplan) {
        if (pathUri[vi].indexOf("furnished") >= 0) {
          // const furnishValFilt = pathUri[vi].replace("furnished-", "")
          furnishVal = true
        }
         }

        if (pathUri[vi].indexOf("completion-") >= 0) {
          const statusTypeValFilt = pathUri[vi].replace("completion-", "")
          statusTypeVal = statusTypeValFilt
        }
        

        // offplan status
        if (pathUri[vi].indexOf("status-") >= 0) {
          const statusValFilt = pathUri[vi].replace("status-", "")
          offplanStatusVal = statusValFilt
        }

        // developer
        if (pathUri[vi].indexOf("developed-by-") >= 0) {
          const developerValFilt = pathUri[vi].replace("developed-by-", "")
          developerVal = developerValFilt
        }

        if (pathUri[vi].indexOf("city-area-") >= 0) {
          const cityValFilt = pathUri[vi].replace("city-area-", "")
          cityVal = cityValFilt?.replace(/-/g, " ")?.replace("umm al quwain", "umm al-quwain")
        }

        // if (pathUri[vi].indexOf("crm-id-") >= 0) {
        //   const crm_idValFilt = pathUri[vi].replace("crm-id-", "")
        //   crm_id = crm_idValFilt
        // }

        // Page
        if (pathUri[vi].indexOf("page") >= 0) {
          pageVal = pathUri[vi].replace("page-", "")
        }

        if (pathUri[vi].indexOf("map-view") >= 0) {
          layoutVal = "map"
        }

        // Branch Val
        if (pathUri[vi].indexOf("branch-") >= 0) {
          branchVal = pathUri[vi].replace("branch-", "")
        }
      }
    }

    return {
      indexVal: indexName,
      departmentVal,
      searchTypeVal,
      areaVal,
      minBedVal,
      maxBedVal,
      bedVal,
      minPriceVal,
      maxPriceVal,
      minAreaSizeVal,
      maxAreaSizeVal,
      pageVal,
      buildingVal,
      sortVal,
      layoutVal,
      mustIncludeVal,
      furnishVal,
      branchVal,
      amenitiesVal,
      offplanStatusVal,
      developerVal,
      cityVal,
      pathname: location.pathname,
      crm_id,
      statusTypeVal,
    }
  }
  return {}
}

export const generateFilters = ({
  departmentVal,
  searchTypeVal,
  areaVal,
  minBedVal,
  maxBedVal,
  bedVal,
  minPriceVal,
  maxPriceVal,
  minAreaSizeVal,
  maxAreaSizeVal,
  buildingVal,
  offplanStatusVal,
  developerVal,
  cityVal,
  furnishVal,
  branchVal,
  amenitiesVal,
  crm_id,
  statusTypeVal,
  pageVal
}) => {
  const isOffplan = departmentVal === "new_developments"
  // lets from the filters
  // here the search login lives
  const myfilter = []

  // facet filters
  if (departmentVal) {
    if (departmentVal === "residential") {
      myfilter.push(`((department:${departmentVal}) OR (department:commercial))`)
    } else {
      myfilter.push(`(department:${departmentVal})`)
    }
  }
  if(crm_id){
    myfilter.push(`(crm_id: ${crm_id})`)
  }
  if (searchTypeVal) {
    myfilter.push(`(search_type:${searchTypeVal})`)
  }
  // if(areaVal && areaVal !== "london"){
  //     myfilter.push("(area:"+areaVal+" OR post_code:"+areaVal+" OR display_address:"+areaVal+")")
  // }

  if (buildingVal && buildingVal !== "properties") {
    const varName = isOffplan ? "building_type" : "building"
    if(isOffplan){
      if (buildingVal === "apartment") {
        buildingVal = `((${varName}:apartment) OR (${varName}:penthouse) OR (${varName}:duplex))`;
        myfilter.push(`${buildingVal}`)
      }
      else if (buildingVal === "villa") {
        buildingVal = `((${varName}:villa) OR (${varName}:townhouse))`;
        myfilter.push(`${buildingVal}`)
      }
      else {
        myfilter.push(`(${varName}:${buildingVal})`)
  
      }
    }
    else {
      if (buildingVal === "apartment") {
        buildingVal = `((${varName}:Apartment) OR (${varName}:Penthouse) OR (${varName}:Duplex))`;
        myfilter.push(`${buildingVal}`)
      }
      else if (buildingVal === "villa") {
        buildingVal = `((${varName}:Villa) OR (${varName}:Townhouse))`;
        myfilter.push(`${buildingVal}`)
      }
      else {
        myfilter.push(`(${varName}:${slugToTitle(buildingVal)?.replace("Whole Building", "Whole building")})`)
  
      }
    }

  }

  if (offplanStatusVal) {
    myfilter.push(`(status:${offplanStatusVal})`)
  }

  if (developerVal) {
    myfilter.push(`(filter_developer:${developerVal})`)
  }
  if (cityVal) {
    myfilter.push(`(country:${cityVal?.replace(/-/g, " ")?.replace("umm al quwain", "umm al-quwain")})`)
  }

  // numberic filters
  if (bedVal && bedVal > 0) {
    myfilter.push(`(bedroom >= ${bedVal})`)
  }

  // bedroom filters
  const minBedText = isOffplan ? "min_bedrooms" : "bedroom"
  const maxBedText = isOffplan ? "max_bedrooms" : "bedroom"
  if (minBedVal && minBedVal >= 0 && maxBedVal && maxBedVal >= 0) {
    myfilter.push(
      `(${minBedText} >= ${minBedVal} AND ${maxBedText} <= ${maxBedVal})`
    )
  } else if (maxBedVal && maxBedVal >= 0) {
    myfilter.push(`(${maxBedText} <= ${maxBedVal})`)
  } else if (minBedVal && minBedVal >= 0) {
    myfilter.push(`(${minBedText} >= ${minBedVal})`)
  }

  // price filters
  if(isOffplan){
    if (minPriceVal && minPriceVal > 0 && maxPriceVal && maxPriceVal > 0) {
      myfilter.push(`(filter_price >= ${minPriceVal} AND filter_price <= ${maxPriceVal})`)
    } else if (maxPriceVal && maxPriceVal > 0) {
      myfilter.push(`(filter_price <= ${maxPriceVal})`)
    } else if (minPriceVal && minPriceVal > 0) {
      myfilter.push(`(filter_price >= ${minPriceVal})`)
    }
  }
  else {
    if (minPriceVal && minPriceVal > 0 && maxPriceVal && maxPriceVal > 0) {
      myfilter.push(`(price >= ${minPriceVal} AND price <= ${maxPriceVal})`)
    } else if (maxPriceVal && maxPriceVal > 0) {
      myfilter.push(`(price <= ${maxPriceVal})`)
    } else if (minPriceVal && minPriceVal > 0) {
      myfilter.push(`(price >= ${minPriceVal})`)
    }
  }

  // area size filters
  if (
    minAreaSizeVal &&
    minAreaSizeVal > 0 &&
    maxAreaSizeVal &&
    maxAreaSizeVal > 0
  ) {
    myfilter.push(
      `(floorarea_max >= ${minAreaSizeVal} AND floorarea_max <= ${maxAreaSizeVal})`
    )
  } else if (maxAreaSizeVal && maxAreaSizeVal > 0) {
    myfilter.push(`(floorarea_max <= ${maxAreaSizeVal})`)
  } else if (minAreaSizeVal && minAreaSizeVal > 0) {
    myfilter.push(`(floorarea_max >= ${minAreaSizeVal})`)
  }

  // area search filters
  if (typeof areaVal === "object" && areaVal.length > 0) {
    let queryStr = ""
    areaVal.forEach((area, index) => {
      queryStr += `search_areas:${area}`
      if (index < areaVal.length - 1) {
        queryStr += " OR "
      }
    })
    if(areaVal.length > 1){
      queryStr = `((${queryStr}))`
    }
    else{
      queryStr = `(${queryStr})`
    }
    
    myfilter.push(queryStr)
  }

  // if(pageVal){
  //     myfilter.push("(page: "+(pageVal)+")")
  // }
  myfilter.push("(publish: true)")

  // Mustinclude
  // if (mustIncludeVal?.length > 0) {
  //   // query += `&refinementList[mustInclude]=` + mustIncludeVal
  //   for (let v = 0; v <= mustIncludeVal.length; v++) {
  //     if (typeof mustIncludeVal[v] !== "undefined") {
  //       myfilter.push(`(mustInclude:${mustIncludeVal[v]})`)
  //     }
  //   }
  // }

  if (furnishVal) {
    myfilter.push("((furnishing:Furnished) OR (furnishing:furnished))")
  }
  if (statusTypeVal) {
    myfilter.push(`(completion_status:${statusTypeVal})`)
  }
  if (branchVal) {
    myfilter.push(`(office_crm_id:${branchVal})`)
  }

  if (amenitiesVal?.length > 0) {
    let queryStr = ""
    amenitiesVal.forEach((amenity, index) => {
      if(isOffplan){
        queryStr += `filter_features:${amenity}`
      }
      else {
        queryStr += `amenities:${amenity}`

      }
      if (index < amenitiesVal.length - 1) {
        queryStr += " OR "
      }
    })
    if(amenitiesVal?.length > 1){
      queryStr = `((${queryStr}))`

    }
    else {
      queryStr = `(${queryStr})`

    }
    myfilter.push(queryStr)
  }
  myfilter.push(`(listing: true)`)
  return myfilter.join(" AND ")
}



export const algogenerateFilters = ({
  departmentVal,
  searchTypeVal,
  areaVal,
  minBedVal,
  maxBedVal,
  bedVal,
  minPriceVal,
  maxPriceVal,
  minAreaSizeVal,
  maxAreaSizeVal,
  buildingVal,
  offplanStatusVal,
  developerVal,
  cityVal,
  furnishVal,
  branchVal,
  amenitiesVal,
  crm_id,
  statusTypeVal,
  pageVal
}) => {
  const isOffplan = departmentVal === "new_developments"
  // lets from the filters
  // here the search login lives
  const myfilter = []

  // facet filters
  if (departmentVal) {
    if (departmentVal === "residential") {
      myfilter.push(`(department:${departmentVal}) OR (department:commercial)`)
    } else {
      myfilter.push(`(department:${departmentVal})`)
    }
  }
  if(crm_id){
    myfilter.push(`(crm_id: ${crm_id})`)
  }
  if (searchTypeVal) {
    myfilter.push(`(search_type:${searchTypeVal})`)
  }
  // if(areaVal && areaVal !== "london"){
  //     myfilter.push("(area:"+areaVal+" OR post_code:"+areaVal+" OR display_address:"+areaVal+")")
  // }

  if (buildingVal && buildingVal !== "properties") {
    const varName = isOffplan ? "building_type" : "building"
    if (buildingVal === "apartment") {
      buildingVal = `(${varName}:apartment) OR (${varName}:penthouse) OR (${varName}:duplex)`;
      myfilter.push(`${buildingVal}`)
    }
    else if (buildingVal === "villa") {
      buildingVal = `(${varName}:villa) OR (${varName}:townhouse)`;
      myfilter.push(`${buildingVal}`)
    }
    else {
      myfilter.push(`(${varName}:${buildingVal})`)

    }
  }

  if (offplanStatusVal) {
    myfilter.push(`(status:${offplanStatusVal})`)
  }

  if (developerVal) {
    myfilter.push(`(developer:${developerVal})`)
  }

  if (cityVal) {
    myfilter.push(`(country:${cityVal?.replace(/-/g, " ")})`)
  }

  // numberic filters
  if (bedVal && bedVal > 0) {
    myfilter.push(`(bedroom >= ${bedVal})`)
  }

  // bedroom filters
  const minBedText = isOffplan ? "min_bedrooms" : "bedroom"
  const maxBedText = isOffplan ? "max_bedrooms" : "bedroom"
  if (minBedVal && minBedVal >= 0 && maxBedVal && maxBedVal >= 0) {
    myfilter.push(
      `(${minBedText} >= ${minBedVal} AND ${maxBedText} <= ${maxBedVal})`
    )
  } else if (maxBedVal && maxBedVal >= 0) {
    myfilter.push(`(${maxBedText} <= ${maxBedVal})`)
  } else if (minBedVal && minBedVal >= 0) {
    myfilter.push(`(${minBedText} >= ${minBedVal})`)
  }

  // price filters
  if (minPriceVal && minPriceVal > 0 && maxPriceVal && maxPriceVal > 0) {
    myfilter.push(`(price >= ${minPriceVal} AND price <= ${maxPriceVal})`)
  } else if (maxPriceVal && maxPriceVal > 0) {
    myfilter.push(`(price <= ${maxPriceVal})`)
  } else if (minPriceVal && minPriceVal > 0) {
    myfilter.push(`(price >= ${minPriceVal})`)
  }

  // area size filters
  if (
    minAreaSizeVal &&
    minAreaSizeVal > 0 &&
    maxAreaSizeVal &&
    maxAreaSizeVal > 0
  ) {
    myfilter.push(
      `(floorarea_max >= ${minAreaSizeVal} AND floorarea_max <= ${maxAreaSizeVal})`
    )
  } else if (maxAreaSizeVal && maxAreaSizeVal > 0) {
    myfilter.push(`(floorarea_max <= ${maxAreaSizeVal})`)
  } else if (minAreaSizeVal && minAreaSizeVal > 0) {
    myfilter.push(`(floorarea_max >= ${minAreaSizeVal})`)
  }

  // area search filters
  if (typeof areaVal === "object" && areaVal.length > 0) {
    let queryStr = ""
    areaVal.forEach((area, index) => {
      queryStr += `search_areas:${area}`
      if (index < areaVal.length - 1) {
        queryStr += " OR "
      }
    })
    queryStr = `(${queryStr})`
    myfilter.push(queryStr)
  }

  // if(pageVal){
  //     myfilter.push("(page: "+(pageVal)+")")
  // }
  myfilter.push("(publish: true)")

  // Mustinclude
  // if (mustIncludeVal?.length > 0) {
  //   // query += `&refinementList[mustInclude]=` + mustIncludeVal
  //   for (let v = 0; v <= mustIncludeVal.length; v++) {
  //     if (typeof mustIncludeVal[v] !== "undefined") {
  //       myfilter.push(`(mustInclude:${mustIncludeVal[v]})`)
  //     }
  //   }
  // }

  if (furnishVal) {
    myfilter.push("(furnished:furnished)")
  }
  if (statusTypeVal) {
    myfilter.push(`(completion_status:${statusTypeVal})`)
  }
  if (branchVal) {
    myfilter.push(`(office_crm_id:${branchVal})`)
  }

  if (amenitiesVal?.length > 0) {
    let queryStr = ""
    amenitiesVal.forEach((amenity, index) => {
      if(isOffplan){
        queryStr += `features:${amenity}`
      }
      else {
        queryStr += `amenities:${amenity}`

      }
      if (index < amenitiesVal.length - 1) {
        queryStr += " OR "
      }
    })
    queryStr = `(${queryStr})`
    myfilter.push(queryStr)
  }
  return myfilter.join(" AND ")
}

export const formatCurrencyOption = ({ option, currencyType }) => {
  const obj = { value: option.value, label: option.label }
  if (option.value === "") {
    return obj
  }
  if (option.value === "AED") {
    obj.label = `${currencyType?.Type} ${option.value?.toLocaleString("en-US")}`
  } else {
    obj.label = `${currencyType?.value} ${parseInt(
      calcPrice(option.value, currencyType?.value, "AED"),
      10
    ).toLocaleString("en-US")}`
  }

  return obj
}

export const getPriceText = (minPrice, maxPrice) => {
  const formattedMinPrice = CurrConvertPrice(minPrice?.toLocaleString("en-US"))
  const formattedMaxPrice = CurrConvertPrice(maxPrice?.toLocaleString("en-US"))
  let text = ""
  if (formattedMinPrice && formattedMaxPrice) {
    text = `between ${formattedMinPrice} and ${formattedMaxPrice}`
  } else if (formattedMinPrice) {
    text = `above ${formattedMinPrice}`
  } else if (formattedMaxPrice) {
    text = `below ${formattedMaxPrice}`
  }
  return text
}

export const getBuildingText = (building) => {
  if (!building) return null

  const text = pluralize(capitalizeText(building?.replace("-", " ")))
  return text
}

export const getBedroomText = (minBedVal, maxBedVal) => {
  let text = ""

  if (minBedVal === "0" || maxBedVal === "0") {
    return ""
  }

  const bedroomText = (bedVal) => {
    const bedValInt = parseInt(bedVal, 10)
    if (bedValInt < 2) {
      return "bedroom"
    }
    return "bedrooms"
  }

  if (minBedVal && maxBedVal) {
    text = `between ${minBedVal} and ${maxBedVal} ${bedroomText(maxBedVal)}`
  } else if (minBedVal) {
    text = `with more than ${minBedVal} ${bedroomText(minBedVal)}`
  } else if (maxBedVal) {
    text = `with less than ${maxBedVal} ${bedroomText(maxBedVal)}`
  }
  return text
}

export const getSizetext = (minSize, maxSize) => {
  let text = ""
  let minSizeNO = SizeConvertNO(minSize)
  let maxSizex = SizeConvert(maxSize)
  let minSizex = SizeConvert(minSize)
  if (minSize && maxSize) {
    text = `between ${minSizeNO} and ${maxSizex}`
  } else if (minSize) {
    text = `above ${minSizex}`
  } else if (maxSize) {
    text = `below ${maxSizex}`
  }
  return text
}

export const getFurnishedText = (furnishVal) => {
  let text = ""
  if(furnishVal){
    text = `with Furnished`
  }
  return text
}

export const convertSlugToCapitalizedText = (slug) => {
  if (!slug) return ""
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

export const getAreasText = (areas) => {
  let text = ""
  if (!areas) return text

  let areaArr = []

  if (!Array.isArray(areas)) {
    areaArr = [areas]
  } else {
    areaArr = areas
  }

  if (areaArr.length > 0) {
    text = `in ${areaArr
      .map((area) => convertSlugToCapitalizedText(area))
      .join(", ")
      .replace(/,([^,]*)$/, " and$1")}`
  }

  return text
}

export const getAmenitiesText = (amenities) => {
  let text = ""

  if (!isEmpty(amenities)) {
    const selectedAmenities = amenitiesOptions.filter((amenity) =>
      amenities.includes(amenity.value)
    )

    if (!isEmpty(selectedAmenities)) {
      text = `with ${selectedAmenities
        .map((amenity) => amenity.label)
        .join(", ")}`
    }
  }

  return text
}


export const getOffAmenitiesText = (amenities) => {
  let text = ""
  const allFeatures = useFeatures()

  if (!isEmpty(amenities)) {
    const selectedAmenities = allFeatures.filter((amenity) =>
      amenities.includes(amenity.slug)
    )

    if (!isEmpty(selectedAmenities)) {
      text = `with ${selectedAmenities
        .map((amenity) => amenity.name)
        .join(", ")}`
    }
  }

  return text
}

export const getDeveloperText = (developer) => {
  let text = ""
  if (developer) {
    text = `developed by ${slugToTitle(developer)}`
  }
  return text
}

export const getCityText = (city) => {
  let text = ""
  if (city) {
    text = `in ${slugToTitle(city)}`
  }
  return text
}

export const getOffplanStatusText = (offplanStatus) => {
  let text = ""
  if (offplanStatus) {
    text = `that are ${slugToTitle(offplanStatus === "pending"? "under-construction" : offplanStatus)}`
  }
  return text.toLowerCase()
}

export const getH1Text = (
  {
    departmentVal,
    searchTypeVal,
    areaVal,
    // bedVal,
    minBedVal,
    maxBedVal,
    minPriceVal,
    maxPriceVal,
    minAreaSizeVal,
    maxAreaSizeVal,
    buildingVal,
    offplanStatusVal,
    developerVal,
    cityVal,
    amenitiesVal,
    furnishVal,
  },
  capitalize = true
) => {
  const isOffplan = departmentVal === "new_developments"
  const isCommercial = departmentVal === "commercial"

  const propertyText = "Properties"

  const defaultAreaText = "Dubai"
  const buyRent = searchTypeVal === "sales" ? "for sale" : "for rent"
  let h1Text = `${propertyText} ${buyRent} in ${defaultAreaText}`
  const areas = getAreasText(areaVal) || `in ${defaultAreaText}`

  let building = getBuildingText(buildingVal) || propertyText
  building = capitalize ? building : building.toLowerCase()

  const price = getPriceText(minPriceVal, maxPriceVal)
  const bedrooms = getBedroomText(minBedVal, maxBedVal)
  const size = getSizetext(minAreaSizeVal, maxAreaSizeVal)
  const amenities = isOffplan ? getOffAmenitiesText(amenitiesVal) : getAmenitiesText(amenitiesVal)
  const developer = getDeveloperText(developerVal)
  const city = getCityText(cityVal)
  const status = getOffplanStatusText(offplanStatusVal)
  const furnished = getFurnishedText(furnishVal)

  let buildingText = building

  if (isOffplan) {
    buildingText = `${
      capitalize ? "Off plan" : "off plan"
    } ${building.toLowerCase()}`
  }

  if (isCommercial) {
    buildingText = `${
      capitalize ? "Commercial" : "commercial"
    } ${building.toLowerCase()}`
  }

  h1Text = `${buildingText} ${buyRent} ${status} ${city ? city : areas} ${amenities} ${price} ${bedrooms} ${size} ${developer} ${furnished}`
  h1Text = h1Text.trim()
  const path =  typeof window !== "undefined" && window.location.pathname
  if(path){
    if(path === "/buy/penthouse-for-sale/"){
      h1Text = "Penthouses for Sale in Dubai | Buy Penthouses in UAE"
    }
    else if(path === "/buy/shop-for-sale/"){
      h1Text = h1Text.trim()
    }
    else if(path === "/let/villa-for-rent/"){
      h1Text = "Furnished Villas & Houses for Rent in Dubai"
    }
    else if(path === "/buy/villa-for-sale/"){
      h1Text = "Luxury Villas for Sale in Dubai | Buy Villa"
    }
    else if(path === "/buy/apartment-for-sale/"){
      h1Text = "Buy Luxury Apartments for Sale in Dubai, UAE"
    }    
    else if(path === "/let/duplex-for-rent/"){
      h1Text = "Duplex Properties For Rent in Dubai"
    }    
    else if(path === "/let/office-space-for-rent/"){
      h1Text = "Office Spaces for Rent in Dubai | Offices for Rent"
    }
    else if(path === "/buy/properties-for-sale/"){
      h1Text = "Property for Sale in Dubai | Buy Dubai Properties"
    }
    else if(path === "/buy/land-for-sale/"){
      h1Text = "Plots and Lands for sale in Dubai UAE"
    }
    else if(path === "/let/properties-for-rent/"){
      h1Text = "Properties for rent  in Dubai, UAE"
    }            
    else if(path === "/let/retail-for-rent/"){
      h1Text = "Flexible Retail spaces for rent in Dubai"
    }
    else if(path === "/let/townhouse-for-rent/"){
      h1Text = "Townhouses For Rent in Dubai | Rent a House in Dubai"
    }    
    else if(path === "/let/whole-building-for-rent/"){
      h1Text = h1Text.trim()
    }
    else if(path === "/let/land-for-rent/"){
      h1Text = "Commercial Lands for Rent in Dubai, UAE"
    }
    else if(path === "/let/shop-for-rent/"){
      h1Text = "Shops for Rent in Dubai | Shops rentals"
    }
    else if(path === "/let/apartment-for-rent/"){
      h1Text = "Apartments & Flats for rent in Dubai, UAE"
    }
    else if(path === "/let/penthouse-for-rent/"){
      h1Text = "Luxury Penthouses for Rent in Dubai, UAE"
    }
    else if(path === "/buy/townhouse-for-sale/"){
      h1Text = "Townhouses for Sale in Dubai | Buy Townhome in Dubai"
    }
    else if(path === "/buy/duplex-for-sale/"){
      h1Text = "Premium Duplexes for Sale in Dubai, UAE"
    }        
  }
  return h1Text
}

export const getSeoDesc = (props) => {
  const {
    searchTypeVal,
    areaVal,
    minBedVal,
    minPriceVal,
    maxPriceVal,
    buildingVal,
  } = props

  const h1Text = getH1Text(props, false)
  const action = searchTypeVal === "sales" ? "for sale" : "for rent"
  const defaultAreaText = "Dubai"
  const areas = getAreasText(areaVal) || `in ${defaultAreaText}`
  const building = buildingVal
  const bedroom = minBedVal
  const minPrice = formatNumber(minPriceVal)
  const maxPrice = formatNumber(maxPriceVal)

  let desc = `Explore our stunning range of ${h1Text}. Contact Provident
  Real Estate to find the right property ${action} ${areas}.`

  if (action) {
    desc = `Looking for ${h1Text}? Contact Provident Real Estate ${
      areas || "Dubai"
    } to find the right property for you.`
  }

  if (building && action && areas) {
    desc = `Explore our latest collection of ${h1Text}. Property experts from Provident Real Estate are here to help.`
  }

  if (bedroom && action && areas) {
    desc = `Explore ${h1Text} here. Contact our expert estate agents today to get assistance in finding the right property ${areas}.`
  }

  if ((minPrice || maxPrice) && (areas || building || bedroom)) {
    desc = `Locate the right ${h1Text} with Provident Real Estate. Book an appointment with one of our property experts ${areas}.`
  }

  if ((minPrice || maxPrice) && building && !bedroom) {
    desc = `Check out the latest collection of ${h1Text} with Provident Real Estate ${areas}.`
  }

  if ((minPrice || maxPrice) && bedroom && !building) {
    desc = `Explore the list of ${h1Text} with Provident Real Estate and request a viewing for the property that interests you.`
  }

  if (building && bedroom && !minPrice && !maxPrice) {
    desc = `Find the latest collection of ${h1Text}. Contact Provident Real Estate and letting agents ${areas} to arrange a viewing.`
  }

  if (minPrice && maxPrice && building && bedroom && action) {
    desc = `Explore ${h1Text} available with Provident Real Estate. Contact one of our estate agents for assistance in finding your property ${areas}.`
  }
   const path =  typeof window !== "undefined" && window.location.pathname
  if(path){
    if(path === "/buy/penthouse-for-sale/"){
      desc = "Dubai penthouses for sale in dubai from provident estate. Discover prime locations, skyline views & 24/7 concierge, your ideal property is just a click away."
    }
    else if(path === "/buy/shop-for-sale/"){
      desc = "Looking to buy a shop in Dubai? Explore commercial shops for sale across prime areas with verified listings, flexible payment plans & high ROI opportunities."
    }
    else if(path === "/let/villa-for-rent/"){
      desc = "Find fully furnished homes and villas for rent in Dubai with Provident Estate. Explore luxury & affordable houses with various layouts, floor plans, amenities & history."
    }
    else if(path === "/buy/villa-for-sale/"){
      desc = "Discover luxury villas for sale in Dubai. Explore top locations, designs, and investment opportunities with high ROI and exclusive lifestyle offerings."
    }
    else if(path === "/buy/apartment-for-sale/"){
      desc = "Buy luxury apartments for sale in Dubai and the UAE with Provident Estate. Explore premium furnished and unfurnished flats with various layouts and top amenities."
    }    
    else if(path === "/let/duplex-for-rent/"){
      desc = "Rent luxury duplexes in Dubai with Provident Estate. Find the perfect duplex for rent in prime Dubai locations. Contact us today!"
    }    
    else if(path === "/let/office-space-for-rent/"){
      desc = "Find flexible office spaces for rent in Dubai. Enjoy modern work environments, prime locations, and customizable options to suit your business needs. Contact Us!"
    }
    else if(path === "/buy/properties-for-sale/"){
      desc = "Find properties for sale in Dubai with service charges, floor plans & mortgage details. Buy real estate in Dubai for investment purposes or to move in."
    }
    else if(path === "/buy/land-for-sale/"){
      desc = "Looking for plots and lands for sale in Dubai. Explore top-notch living spaces with luxurious amenities and prime locations. Find your dream property today!"
    }
    else if(path === "/let/properties-for-rent/"){
      desc = "Property to rent in Dubai from Provident Esate, world leading estate agents. From country estates to city apartments, your ideal property is just a click away."
    }            
    else if(path === "/let/retail-for-rent/"){
      desc = "Flexible Retail spaces for rent in Dubai across prime commercial locations. Find small, large, and premium spaces with Driven Properties. Contact Us!"
    }
    else if(path === "/let/townhouse-for-rent/"){
      desc = "Browse luxury townhouses for rent in Dubai with Provident Estate. Find modern, family-friendly rental homes in top Dubai communities. Schedule a viewing today!"
    }    
    else if(path === "/let/whole-building-for-rent/"){
      desc = "Find whole buildings for rent in Dubai with Provident Estate. Ideal for businesses & investors. Browse premium commercial and residential options now."
    }
    else if(path === "/let/land-for-rent/"){
      desc = "Browse premium commercial lands for rent in Dubai, UAE with Provident Estate. Ideal for businesses seeking high-visibility locations. Inquire today!"
    }
    else if(path === "/let/shop-for-rent/"){
      desc = "Find shops for rent in Dubai with Provident Estate. Explore prime retail spaces and commercial shop rentals in top business locations across the city."
    }
    else if(path === "/let/apartment-for-rent/"){
      desc = "Browse apartments and flats for rent in Dubai, UAE with Provident Estate. Find the perfect rental home in top communities at competitive prices. Contact Us!"
    }
    else if(path === "/let/penthouse-for-rent/"){
      desc = "Experience upscale living with luxury penthouses for rent in Dubai. Explore premium spaces with stunning views, only with Provident Estate. Book your tour today!"
    }
    else if(path === "/buy/townhouse-for-sale/"){
      desc = "Experience upscale living with luxury penthouses for rent in Dubai. Explore premium spaces with stunning views, only with Provident Estate. Book your tour today!"
    }
    else if(path === "/buy/duplex-for-sale/"){
      desc = "Browse premium duplexes for sale in Dubai with Provident Estate. Modern layouts, prime locations, and expert guidance for luxury living in the UAE."
    }        
  }
  return desc
}


// Create Canonical URL
export const createResultsCanonicalUrl = ({pageUrlData
  
}) => {

  const {departmentVal,
    searchTypeVal,
    areaVal,
    minBedVal,
    maxBedVal,
    minPriceVal,
    maxPriceVal,
    minAreaSizeVal,
    maxAreaSizeVal,
    buildingVal,
    sortVal,
    amenitiesVal,
    offplanStatusVal,
    developerVal,
    cityVal,
    furnishVal,
    crm_id} = pageUrlData
  const isResidential = departmentVal === "residential"
  const isOffplan = departmentVal === "new_developments"
  const isCommercial = departmentVal === "commercial"

  let url = ""

  if (searchTypeVal === "sales") {
    if (isResidential) {
      url = propertiesSaleURL
    } else if (isCommercial) {
      url = commercialPropertiesSaleURL
    } else if (isOffplan) {
      url = offplanResultsURL
    }
  } else if (searchTypeVal === "lettings") {
    if (isResidential) {
      url = propertiesRentURL
    } else if (isCommercial) {
      url = commercialPropertiesRentURL
    }
  }

  url += getAreaPath(areaVal)
  if (isOffplan) {
    url += getProppertyTypePath(buildingVal)
  } else {
    url = updatePropertyTypePath(buildingVal, url)
  }
  // url += getPricePath(minPriceVal, maxPriceVal)
  // url += getBedroomPath(minBedVal, maxBedVal)
  // url += getSizePath(minAreaSizeVal, maxAreaSizeVal)
  // url += getAmenitesPath(amenitiesVal)
  // url += getOffplanStatusPath(offplanStatusVal)
  url += getDeveloperPath(developerVal)
  url += getCityPath(cityVal)
  // url += getFurnishedPath(furnishVal)
  // url += getSortPath(sortVal)
  // url += getCrmidPath(crm_id)
  return addTraillingSlash(url)
}
